import React from 'react';
import styled from 'styled-components';

import Layout from '@/layout';

import Hero from './components/Hero';
import Description from './components/Description';
import Gallery from './components/Gallery';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import Text from './components/Text';

function TokensLanding() {
  return (
    <Layout>
      <Component>
        <Hero />
        <Description />
        <Gallery />
        <About />
        <HowItWorks />
        <Text />
      </Component>
    </Layout>
  );
}

export default TokensLanding;

const Component = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.white};
`;
